import { render } from "./SimpleButton.vue?vue&type=template&id=1fb6bd16&scoped=true"
import script from "./SimpleButton.vue?vue&type=script&lang=js"
export * from "./SimpleButton.vue?vue&type=script&lang=js"

import "./SimpleButton.vue?vue&type=style&index=0&id=1fb6bd16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1fb6bd16"

export default script